import { listen, qs, qsa } from "@fluorescent/dom";

import { section } from "@/glow";

section("cart", {
  onLoad() {
    const { enableCartAjax } = this.container.dataset;
    const ajaxEnabled = enableCartAjax === "true";
    this.form = qs("[data-form]", this.container);

    if (!this.form) return;
    const buttons = qsa("[data-change]", this.container);
    const quantityInputs = qsa("[data-quantity-input]", this.container);

    this.timer;
    this.loadingOverlay = qs("[data-cart-loading]", this.container);

    this.events = [
      listen(buttons, "click", e => {
        e.preventDefault();
        const { change } = e.currentTarget.dataset;
        const input = qs("input", e.currentTarget.parentNode);

        if (change === "increment") {
          input.value >= 0 && input.value++;
        } else if (change === "decrement") {
          input.value > 0 && input.value--;
        }

        if (ajaxEnabled) this.handleTimeout();
      }),
    ];

    if (ajaxEnabled) {
      quantityInputs.forEach(input => {
        this.events.push(listen(input, "input", () => this.handleTimeout()));
      });
    }

    // Sticky checkout panel logic for tablet/mobile
    this.checkoutPanel = qs("[data-checkout-panel]", this.container);
    this.checkoutCol = qs("[data-checkout-col]", this.container);
    this.itemsCol = qs(".ojo-cart__items-col", this.container);

    if (this.checkoutPanel && this.itemsCol) {
      this.initStickyCheckout();
    }
  },

  initStickyCheckout() {
    const mediaQuery = window.matchMedia("(max-width: 1279px)");

    const handleSticky = () => {
      if (!mediaQuery.matches) {
        // Desktop: no sticky
        this.checkoutPanel.classList.remove("ojo-cart__checkout--sticky");
        if (this._scrollHandler) {
          window.removeEventListener("scroll", this._scrollHandler);
          this._scrollHandler = null;
        }
        return;
      }

      // Only activate sticky if there are enough items
      const itemsRect = this.itemsCol.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // If items column is taller than viewport, enable sticky
      if (this.itemsCol.scrollHeight > viewportHeight * 0.8) {
        this._scrollHandler = () => {
          const checkoutColRect = this.checkoutCol.getBoundingClientRect();
          const itemsBottom = this.itemsCol.getBoundingClientRect().bottom;

          // If items are still being scrolled through (bottom of items below viewport)
          if (itemsBottom > viewportHeight - 20) {
            this.checkoutPanel.classList.add("ojo-cart__checkout--sticky");
          } else {
            this.checkoutPanel.classList.remove("ojo-cart__checkout--sticky");
          }
        };

        window.addEventListener("scroll", this._scrollHandler, { passive: true });
        this._scrollHandler(); // Initial check
      }
    };

    handleSticky();
    mediaQuery.addEventListener("change", handleSticky);
    this._mediaQuery = mediaQuery;
    this._handleSticky = handleSticky;
  },

  showLoading() {
    if (this.loadingOverlay) {
      this.loadingOverlay.classList.add("is-active");
    }
  },

  handleTimeout() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.showLoading();
      this.form.submit();
    }, 1000);
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    if (this._scrollHandler) {
      window.removeEventListener("scroll", this._scrollHandler);
    }
    if (this._mediaQuery && this._handleSticky) {
      this._mediaQuery.removeEventListener("change", this._handleSticky);
    }
  },
});
